import DOMObserver from '../globals/domobserver';

/**
 * @typedef {{
 *  classes: {
 *    element: string,
 *    initializedModifier: string,
 *    hoverModifier: string,
 *  },
 *  cursorStyle: string
 * }} OverlayLinkOptions
 */

/** @type {OverlayLinkOptions} */
const OverlayLinkDefaultOptions = {
  classes: {
    element: 'js-overlay-link',
    initializedModifier: 'overlay-link--initialized',
    hoverModifier: 'active-overlay',
  },
  cursorStyle: 'pointer',
};

export default function generateOverlayLinks() {
  const { element, initializedModifier } = OverlayLinkDefaultOptions.classes;

  document
    .querySelectorAll(`.${element}:not(.${initializedModifier})`)
    .forEach((/** @type {HTMLElement} */ $link) => {
      /** @type {HTMLElement} */
      const $target = $link.closest(`.${$link.dataset.overlayTarget}`);
      let down;
      let up;

      if ($target) {
        $target.addEventListener('mouseover', () => {
          $target.classList.add(OverlayLinkDefaultOptions.classes.hoverModifier);
          $target.style.cursor = OverlayLinkDefaultOptions.cursorStyle;
        });

        $target.addEventListener('mouseout', () => {
          $target.classList.remove(OverlayLinkDefaultOptions.classes.hoverModifier);
          $target.removeAttribute('style');
        });

        // prevent click while user-selection
        $target.addEventListener('mousedown', () => {
          down = new Date();
        });

        $target.addEventListener('mouseup', (e) => {
          up = new Date();

          if (((up - down) < 200) && (e.button !== 2)) {
            $link.click();
          }
        });

        $link.addEventListener('click', (e) => {
          // prevent double link clicks firing
          if (e.target !== $link) {
            e.preventDefault();
          }
        });

        $link.classList.add(OverlayLinkDefaultOptions.classes.initializedModifier);
      }
    });
}

const linkObserver = new DOMObserver();
linkObserver.watch(document, () => {
  generateOverlayLinks();
});

generateOverlayLinks();
